<template>
  <div v-if="value" class="review-data-modal" role="dialog" aria-modal="true" aria-labelledby="review-data-title">
    <div class="review-data-modal__backdrop" @click="close" />

    <section class="review-data-modal__panel">
      <header class="review-data-modal__header">
        <div>
          <h2 id="review-data-title" class="review-data-modal__title">
            {{ $t('app.assessment_mode.text.input.review_data') }}
          </h2>
          <p class="review-data-modal__patient">
            {{ $t('app.assessment_mode.text.input.patient_header') }} {{ patient.id }} - {{ patient.gender }} - {{ patient.age }}
          </p>
        </div>

        <button
          class="review-data-modal__close"
          type="button"
          :aria-label="$t('app.assessment_mode.text.input.close_review_data')"
          @click="close"
        >
          <v-icon>{{ icons.mdiClose }}</v-icon>
        </button>
      </header>

      <div class="review-data-modal__body">
        <EvidencePanel
          :categories="categories"
          read-only
        />
      </div>

      <footer v-if="allowCopyPaste" class="review-data-modal__footer">
        <copy-clipboard-button
          token="app.assessment.summary.button.copy.title"
          name="summary"
          css-class="copy-all-btn review-data-modal__copy"
          :payload="getCopyPayload"
          mode="button"
        />
      </footer>
    </section>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { mapState } from 'pinia';
import icons from '@/mixins/icons';
import EvidencePanel from '@/features/text-mode/components/Evidence/EvidencePanel.vue';
import CopyClipboardButton from '@/components/widgets/CopyClipboardButton.vue';
import { usePartnerConfigStore } from '@/stores/partnerConfig';
import {
  buildEvidenceSummaryCopyPayload,
  type CopyIdentifier,
} from '@/utils/encounterCopyUtils';
import type { EvidenceCategory } from '@/features/text-mode/types/text-mode.types';
import type { PatientInfo } from '../types/overall-assessment.types';

export default defineComponent({
  name: 'ReviewDataModal',

  components: {
    EvidencePanel,
    CopyClipboardButton,
  },

  mixins: [icons],

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    patient: {
      type: Object as PropType<PatientInfo>,
      required: true,
    },
    categories: {
      type: Array as PropType<EvidenceCategory[]>,
      required: true,
    },
    copyIdentifiers: {
      type: Array as PropType<CopyIdentifier[]>,
      default: () => [],
    },
  },

  computed: {
    ...mapState(usePartnerConfigStore, ['allowCopyPaste']),
  },

  methods: {
    close(): void {
      this.$emit('input', false);
    },
    getCopyPayload(): string {
      return buildEvidenceSummaryCopyPayload({
        identifiers: this.copyIdentifiers,
        categories: this.categories,
        translate: token => String(this.$t(token)),
        formatNumber: value => String(this.$n(value, 'decimal')),
        rtl: this.$vuetify.rtl,
      });
    },
  },
});
</script>
